import { Box, Chip, Tooltip } from "@mui/material";
import { alpha, darken } from "@mui/material/styles";

export default function GuestBadges({ badges, color = "#47856b" }) {
  if (!Array.isArray(badges) || !badges.length) return null;

  return (
    <Box display="flex" flexWrap="wrap" gap={0.5} mt={1}>
      {badges.filter(Boolean).map((badge, index) => (
        <Tooltip key={`${badge.type}-${badge.key}-${index}`} title={badge.description || ""}>
          <Chip
            label={badge.title}
            size="small"
            sx={{
              height: "auto",
              minHeight: 18,
              maxWidth: "100%",
              bgcolor: alpha(badge.color || color, 0.12),
              border: `1px solid ${alpha(badge.color || color, 0.35)}`,
              color: darken(badge.color || color, 0.3),
              fontWeight: 400,
              fontSize: 9,
              "& .MuiChip-label": { px: 0.8, py: 0.3, whiteSpace: "normal", overflowWrap: "anywhere" },
            }}
          />
        </Tooltip>
      ))}
    </Box>
  );
}
